import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicePage from './pages/ServicePage';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import { Helmet } from 'react-helmet-async';

const App: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Dra. Suni Wiphala Chipana Flores - Medicina Integral</title>
        <meta name="description" content="Atención médica integral con enfoque en salud pública comunitaria. Acompañamiento personalizado de pacientes con un enfoque integral y humanizado en Santiago de Chile." />
      </Helmet>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/servicios/:slug" element={<ServicePage />} />
        </Routes>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
};

export default App;